import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import DocumentList from './DocumentList';
import ProcessDetail from '../ProcessDetail';
import { useTranslation } from 'react-i18next';
import API from '../../api-graphql';
import PageContentError from '../UI/PageContentError';

const DocumentFinishedRoute = () => {
  const match = useRouteMatch();
  const { path } = match;
  const { t } = useTranslation();

  const getDocumentData = async (setMessage, setItem, setError, setLoading, id) => {
    setMessage(t('processDetail:loading'));
    try {
      let result = await API.getDocument(id);
      setItem(result.data.getDocument);
    } catch (error) {
      console.error('ERROR getting document');
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Switch>
      <Route exact path={path}>
        {(props) => <DocumentList {...props} currentPath='/document/finished' />}
      </Route>
      <Route exact path={`${path}/detail/:id`}>
        {(props) => <ProcessDetail {...props} type='document' getItemData={getDocumentData} />}
      </Route>
      <Route path='*' component={PageContentError} />
    </Switch>
  );
};

export default DocumentFinishedRoute;
